import React from 'react';
import i18n from 'i18next';
import {Button} from './button';

export const TilbakeButton = () => (
    <div className="tilbake-button-wrapper">
        <Button id="tilbake"
                text={i18n.t('betaling:tilbake')}
                isPrimary
                onClick={() => window.location.href = '/minjegerside'}
        />
    </div>
);
